import * as Actions from '../../actions';

const initialState = { data: null };

const listProducerHaulingContractReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_PRODUCER_HAULING_CONTRACT_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listProducerHaulingContractReducer;
